import { useNavigate } from 'react-router-dom'

export default function Home() {
  const navigate = useNavigate()

  return (
    <div style={{ fontFamily: "'Inter', 'Manrope', sans-serif", background: '#0b1326', minHeight: '100vh', color: '#dae2fd' }}>
      {/* ── Top Nav ─────────────────────────────────────────────────────── */}
      <nav style={{
        position: 'fixed', top: 0, width: '100%', zIndex: 50,
        background: 'rgba(11,19,38,0.85)', backdropFilter: 'blur(20px)',
        borderBottom: '1px solid rgba(68,70,83,0.2)',
      }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 2rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 68 }}>
          {/* Logo */}
          <div style={{ fontSize: '1.4rem', fontWeight: 800, letterSpacing: '-0.04em', color: '#dae2fd' }}>
            InstantDr<span style={{ color: '#b8c4ff' }}>Consult</span>
          </div>

          {/* Nav links */}
          <div className="d-none d-md-flex" style={{ gap: '2rem', alignItems: 'center' }}>
            {['Services', 'How it Works', 'About Us'].map(link => (
              <a key={link} href="#" style={{ color: '#c4c5d5', textDecoration: 'none', fontWeight: 600, fontSize: '0.95rem', transition: 'color 0.2s' }}
                onMouseOver={e => e.target.style.color = '#dae2fd'}
                onMouseOut={e => e.target.style.color = '#c4c5d5'}>
                {link}
              </a>
            ))}
          </div>

          {/* CTA buttons */}
          <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
            <button
              onClick={() => navigate('/login')}
              style={{
                background: 'transparent', border: 'none', color: '#c4c5d5',
                fontWeight: 600, padding: '0.5rem 1rem', cursor: 'pointer',
                fontSize: '0.95rem', transition: 'color 0.2s',
              }}
              onMouseOver={e => e.target.style.color = '#dae2fd'}
              onMouseOut={e => e.target.style.color = '#c4c5d5'}
            >
              Login
            </button>
            <button
              onClick={() => navigate('/login')}
              style={{
                background: 'linear-gradient(135deg, #1e40af 0%, #b8c4ff 100%)',
                border: 'none', color: '#001453', padding: '0.6rem 1.4rem',
                borderRadius: 9999, fontWeight: 700, cursor: 'pointer',
                fontSize: '0.9rem', boxShadow: '0 8px 32px rgba(0,0,0,0.36)',
                transition: 'transform 0.15s',
              }}
              onMouseDown={e => e.currentTarget.style.transform = 'scale(0.97)'}
              onMouseUp={e => e.currentTarget.style.transform = 'scale(1)'}
            >
              Start AI Consultation
            </button>
          </div>
        </div>
      </nav>

      {/* ── Hero ────────────────────────────────────────────────────────── */}
      <section style={{ minHeight: '92vh', display: 'flex', alignItems: 'center', paddingTop: 96, paddingBottom: 48, position: 'relative', overflow: 'hidden' }}>
        {/* Background blobs */}
        <div style={{ position: 'absolute', top: -96, right: -96, width: 384, height: 384, background: 'rgba(184,196,255,0.07)', borderRadius: '50%', filter: 'blur(120px)', pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', top: '50%', left: -96, width: 256, height: 256, background: 'rgba(74,225,118,0.04)', borderRadius: '50%', filter: 'blur(100px)', pointerEvents: 'none' }} />

        <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 2rem', width: '100%', display: 'grid', gridTemplateColumns: '1fr', gap: '3rem', alignItems: 'center' }}
          className="hero-grid">
          {/* Left copy */}
          <div style={{ maxWidth: 680 }}>
            {/* Badge */}
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
              background: 'rgba(45,52,73,0.5)', padding: '0.4rem 1rem', borderRadius: 9999, marginBottom: '2rem',
            }}>
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#4ae176', display: 'inline-block', animation: 'pulse 1.5s infinite' }} />
              <span style={{ fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#4ae176' }}>AI Luminary Active</span>
            </div>

            {/* Headline */}
            <h1 style={{ fontFamily: 'Manrope, Inter, sans-serif', fontWeight: 800, fontSize: 'clamp(2.2rem, 5vw, 4.2rem)', lineHeight: 1.1, letterSpacing: '-0.04em', marginBottom: '1.5rem', color: '#dae2fd' }}>
              Instant Medical Advice.<br />
              <span style={{ color: '#b8c4ff' }}>Real Doctors.</span><br />
              Intelligent AI.
            </h1>

            {/* Sub */}
            <p style={{ color: '#c4c5d5', fontSize: '1.1rem', lineHeight: 1.7, maxWidth: 580, marginBottom: '2.5rem' }}>
              InstantDrConsult combines advanced medical AI, telehealth consultations, and secure patient records into one powerful platform designed to deliver faster, smarter healthcare.
            </p>

            {/* Action buttons */}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
              <button
                onClick={() => navigate('/login')}
                style={{
                  display: 'flex', alignItems: 'center', gap: '0.6rem',
                  background: 'linear-gradient(135deg, #1e40af 0%, #b8c4ff 100%)',
                  border: 'none', color: '#fff', padding: '1rem 2rem',
                  borderRadius: 9999, fontWeight: 700, fontSize: '1rem', cursor: 'pointer',
                  transition: 'box-shadow 0.2s, transform 0.15s',
                }}
                onMouseOver={e => e.currentTarget.style.boxShadow = '0 0 24px rgba(184,196,255,0.45)'}
                onMouseOut={e => e.currentTarget.style.boxShadow = 'none'}
                onMouseDown={e => e.currentTarget.style.transform = 'scale(0.97)'}
                onMouseUp={e => e.currentTarget.style.transform = 'scale(1)'}
              >
                <i className="bi bi-clipboard2-pulse-fill" style={{ fontSize: '1.1rem' }} />
                Start AI Consultation
              </button>

              <button
                onClick={() => navigate('/book-appointment')}
                style={{
                  display: 'flex', alignItems: 'center', gap: '0.6rem',
                  background: 'rgba(45,52,73,0.3)', border: '1px solid rgba(68,70,83,0.2)',
                  color: '#dae2fd', padding: '1rem 2rem',
                  borderRadius: 9999, fontWeight: 700, fontSize: '1rem', cursor: 'pointer',
                  transition: 'background 0.2s, transform 0.15s',
                }}
                onMouseOver={e => e.currentTarget.style.background = 'rgba(45,52,73,0.7)'}
                onMouseOut={e => e.currentTarget.style.background = 'rgba(45,52,73,0.3)'}
                onMouseDown={e => e.currentTarget.style.transform = 'scale(0.97)'}
                onMouseUp={e => e.currentTarget.style.transform = 'scale(1)'}
              >
                <i className="bi bi-calendar2-check-fill" style={{ fontSize: '1.1rem' }} />
                Book Doctor Appointment
              </button>
            </div>
          </div>

          {/* Right card */}
          <div className="d-none d-lg-block" style={{ marginLeft: 'auto', width: '100%', maxWidth: 420 }}>
            <div style={{
              background: 'rgba(45,52,73,0.4)', backdropFilter: 'blur(12px)',
              borderRadius: '2rem', padding: '2rem', border: '1px solid rgba(68,70,83,0.15)',
              boxShadow: '0 24px 64px rgba(0,0,0,0.4)',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
                <div style={{ width: 48, height: 48, borderRadius: '50%', background: 'rgba(74,225,118,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="bi bi-stars" style={{ color: '#4ae176', fontSize: '1.3rem' }} />
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: '1rem', color: '#dae2fd' }}>AI Pulse Analysis</div>
                  <div style={{ fontSize: '0.8rem', color: '#c4c5d5' }}>Real-time health monitoring</div>
                </div>
              </div>

              {/* Placeholder waveform */}
              <div style={{ height: 120, borderRadius: '0.75rem', background: 'rgba(6,14,32,0.5)', border: '1px solid rgba(68,70,83,0.1)', marginBottom: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                <svg viewBox="0 0 300 80" style={{ width: '90%', opacity: 0.55 }}>
                  <polyline points="0,40 30,40 45,10 60,70 75,20 90,60 105,40 120,40 135,15 150,65 165,30 180,50 195,40 210,40 225,25 240,55 255,35 270,45 300,40"
                    fill="none" stroke="#b8c4ff" strokeWidth="2" strokeLinejoin="round" />
                </svg>
              </div>

              {/* Stats */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                {[{ label: 'Response Time', value: '0.4s', color: '#dae2fd' }, { label: 'Accuracy', value: '99.8%', color: '#4ae176' }].map(s => (
                  <div key={s.label} style={{ background: 'rgba(19,27,46,0.8)', padding: '1rem', borderRadius: '1rem' }}>
                    <div style={{ fontSize: '0.75rem', color: '#c4c5d5', marginBottom: '0.25rem' }}>{s.label}</div>
                    <div style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 700, fontSize: '1.4rem', color: s.color }}>{s.value}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Benefits Bento ──────────────────────────────────────────────── */}
      <section style={{ padding: '6rem 2rem', background: 'rgba(19,27,46,0.6)' }}>
        <div style={{ maxWidth: 1280, margin: '0 auto' }}>
          <h2 style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 700, fontSize: 'clamp(1.6rem,3vw,2.4rem)', textAlign: 'center', marginBottom: '1rem', color: '#dae2fd' }}>Precision Intelligence</h2>
          <p style={{ color: '#c4c5d5', textAlign: 'center', maxWidth: 560, margin: '0 auto 3.5rem', lineHeight: 1.7 }}>
            Engineered for accuracy, built for people. Our dual-intelligence model ensures you get the speed of AI with the trust of MDs.
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '1.5rem' }}>
            {[
              { icon: 'bi-clock-fill', iconColor: '#b8c4ff', bg: 'rgba(184,196,255,0.08)', title: '24/7 Availability', desc: 'Access clinical-grade advice any time of day or night, from anywhere in the world.', badge: null },
              { icon: 'bi-cpu-fill', iconColor: '#4ae176', bg: 'rgba(74,225,118,0.08)', title: 'AI + MD Dual Intelligence', desc: 'Our proprietary LLMs work in tandem with board-certified physicians to validate every diagnosis.', badge: 'CORE FEATURE' },
              { icon: 'bi-lightning-fill', iconColor: '#d2bbff', bg: 'rgba(210,187,255,0.08)', title: 'Instant Responses', desc: 'No more waiting rooms. Get initial assessments and guidance in under 60 seconds.', badge: null },
              { icon: 'bi-shield-lock-fill', iconColor: '#c4c5d5', bg: 'rgba(196,197,213,0.06)', title: 'Secure & Encrypted', desc: 'AES-256 encryption protects your medical history. HIPAA and GDPR compliant architecture.', badge: null },
              { icon: 'bi-file-earmark-medical-fill', iconColor: '#b8c4ff', bg: 'rgba(184,196,255,0.06)', title: 'Automated Medical Letters', desc: 'Generate verifiable prescriptions, referral letters, and sick notes approved by our medical team.', badge: null },
            ].map(card => (
              <div key={card.title} style={{
                background: 'rgba(23,31,51,0.8)', border: '1px solid rgba(68,70,83,0.12)',
                borderRadius: '2rem', padding: '2rem', display: 'flex', flexDirection: 'column', gap: '0.75rem',
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ width: 52, height: 52, borderRadius: '0.875rem', background: card.bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <i className={`bi ${card.icon}`} style={{ color: card.iconColor, fontSize: '1.4rem' }} />
                  </div>
                  {card.badge && (
                    <span style={{ fontSize: '0.65rem', fontWeight: 700, color: '#4ae176', background: 'rgba(74,225,118,0.1)', padding: '0.25rem 0.6rem', borderRadius: 9999, letterSpacing: '0.06em' }}>{card.badge}</span>
                  )}
                </div>
                <div style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 700, fontSize: '1.05rem', color: '#dae2fd' }}>{card.title}</div>
                <div style={{ color: '#c4c5d5', fontSize: '0.87rem', lineHeight: 1.65 }}>{card.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Feature Highlights ──────────────────────────────────────────── */}
      <section style={{ padding: '6rem 2rem' }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '8rem' }}>

          {/* Feature 1 */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))', gap: '4rem', alignItems: 'center' }}>
            <div style={{ order: 2 }}>
              <span style={{ fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#4ae176', background: 'rgba(74,225,118,0.1)', padding: '0.3rem 0.75rem', borderRadius: 9999 }}>Intelligence Layer</span>
              <h3 style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 700, fontSize: 'clamp(1.5rem,2.5vw,2.2rem)', lineHeight: 1.2, margin: '1rem 0', color: '#dae2fd' }}>AI Medical Consultation that actually listens.</h3>
              <p style={{ color: '#c4c5d5', lineHeight: 1.75, marginBottom: '1.5rem' }}>
                Our AI doesn't just scan keywords; it understands context. It asks follow-up questions just like a doctor would, narrowing down possibilities to ensure the most accurate triage.
              </p>
              <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                {['Symptom-aware deep questioning', 'Immediate pathology lab referrals'].map(item => (
                  <li key={item} style={{ display: 'flex', gap: '0.6rem', alignItems: 'flex-start' }}>
                    <i className="bi bi-check-circle-fill" style={{ color: '#4ae176', marginTop: 3 }} />
                    <span style={{ color: '#dae2fd' }}>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div style={{ order: 1, position: 'relative' }}>
              <div style={{ position: 'absolute', inset: -16, background: 'rgba(184,196,255,0.12)', borderRadius: '50%', filter: 'blur(48px)' }} />
              <div style={{ position: 'relative', background: 'rgba(30,40,65,0.7)', borderRadius: '2.5rem', padding: '1rem', border: '1px solid rgba(68,70,83,0.2)' }}>
                <div style={{ background: 'rgba(11,19,38,0.8)', borderRadius: '2rem', padding: '2rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                  {[['Patient', 'I have a headache and fever since yesterday'], ['AI Doctor', 'How high is the fever? Any other symptoms like sore throat or body aches?'], ['Patient', 'Fever is 38.5°C, mild sore throat']].map(([role, msg]) => (
                    <div key={msg} style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start', flexDirection: role === 'Patient' ? 'row-reverse' : 'row' }}>
                      <div style={{ width: 32, height: 32, borderRadius: '50%', background: role === 'AI Doctor' ? 'rgba(74,225,118,0.2)' : 'rgba(184,196,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: '0.75rem', fontWeight: 700, color: role === 'AI Doctor' ? '#4ae176' : '#b8c4ff' }}>{role === 'AI Doctor' ? 'AI' : 'P'}</div>
                      <div style={{ background: role === 'AI Doctor' ? 'rgba(45,52,73,0.8)' : 'rgba(30,64,175,0.3)', borderRadius: '0.75rem', padding: '0.6rem 1rem', maxWidth: '80%', fontSize: '0.82rem', color: '#dae2fd', lineHeight: 1.5 }}>{msg}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Feature 2 */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))', gap: '4rem', alignItems: 'center' }}>
            <div style={{ position: 'relative' }}>
              <div style={{ position: 'absolute', inset: -16, background: 'rgba(210,187,255,0.12)', borderRadius: '50%', filter: 'blur(48px)' }} />
              <div style={{ position: 'relative', background: 'rgba(30,40,65,0.7)', borderRadius: '2.5rem', padding: '1rem', border: '1px solid rgba(68,70,83,0.2)' }}>
                <div style={{ background: '#111', borderRadius: '2rem', height: 220, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <div style={{ textAlign: 'center', color: '#c4c5d5' }}>
                    <i className="bi bi-camera-video-fill" style={{ fontSize: '3rem', color: '#b8c4ff', display: 'block', marginBottom: '0.75rem' }} />
                    <div style={{ fontSize: '0.9rem', fontWeight: 600 }}>HD Video Consultation</div>
                    <div style={{ fontSize: '0.75rem', marginTop: '0.25rem', color: '#8e909f' }}>End-to-end encrypted · 100ms</div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <span style={{ fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#d2bbff', background: 'rgba(210,187,255,0.1)', padding: '0.3rem 0.75rem', borderRadius: 9999 }}>Human Layer</span>
              <h3 style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 700, fontSize: 'clamp(1.5rem,2.5vw,2.2rem)', lineHeight: 1.2, margin: '1rem 0', color: '#dae2fd' }}>HD Video Consultations, Anywhere.</h3>
              <p style={{ color: '#c4c5d5', lineHeight: 1.75, marginBottom: '1.5rem' }}>
                Seamlessly transition from AI chat to a live video call with top-rated physicians. High-fidelity audio and video ensure nothing is lost in translation.
              </p>
              <button
                onClick={() => navigate('/login')}
                style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', background: 'none', border: 'none', color: '#b8c4ff', fontWeight: 700, fontSize: '0.95rem', cursor: 'pointer', padding: 0, textDecoration: 'underline' }}>
                Meet our clinical panel <i className="bi bi-arrow-right" />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA ─────────────────────────────────────────────────────────── */}
      <section style={{ padding: '6rem 2rem' }}>
        <div style={{
          maxWidth: 1000, margin: '0 auto', borderRadius: '3rem',
          background: 'linear-gradient(135deg, #1e40af 0%, #002584 100%)',
          padding: '4rem 3rem', textAlign: 'center', position: 'relative', overflow: 'hidden',
        }}>
          <div style={{ position: 'absolute', top: 0, right: 0, width: 256, height: 256, background: 'rgba(255,255,255,0.05)', borderRadius: '50%', transform: 'translate(50%,-50%)', filter: 'blur(48px)' }} />
          <div style={{ position: 'relative', zIndex: 1 }}>
            <h2 style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 800, fontSize: 'clamp(2rem,4vw,3.5rem)', color: '#fff', letterSpacing: '-0.04em', marginBottom: '1rem' }}>Ready for better care?</h2>
            <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '1.1rem', maxWidth: 560, margin: '0 auto 2.5rem', lineHeight: 1.65 }}>
              Join over 500,000 patients using InstantDrConsult to manage their wellness with the power of modern technology.
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1rem' }}>
              <button
                onClick={() => navigate('/login')}
                style={{ background: '#fff', border: 'none', color: '#1e40af', padding: '1rem 2.5rem', borderRadius: 9999, fontWeight: 700, fontSize: '1rem', cursor: 'pointer', transition: 'transform 0.15s' }}
                onMouseDown={e => e.currentTarget.style.transform = 'scale(0.97)'}
                onMouseUp={e => e.currentTarget.style.transform = 'scale(1)'}
              >
                Get Started Free
              </button>
              <button
                style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.35)', color: '#fff', padding: '1rem 2.5rem', borderRadius: 9999, fontWeight: 700, fontSize: '1rem', cursor: 'pointer', transition: 'background 0.2s, transform 0.15s' }}
                onMouseOver={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
                onMouseOut={e => e.currentTarget.style.background = 'transparent'}
                onMouseDown={e => e.currentTarget.style.transform = 'scale(0.97)'}
                onMouseUp={e => e.currentTarget.style.transform = 'scale(1)'}
              >
                For Enterprise
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ── Footer ──────────────────────────────────────────────────────── */}
      <footer style={{ background: '#0b1326', padding: '3rem 2rem', borderTop: '1px solid rgba(68,70,83,0.15)' }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(160px,1fr))', gap: '2rem' }}>
          <div>
            <div style={{ fontWeight: 700, fontSize: '1.05rem', color: '#dae2fd', marginBottom: '0.75rem' }}>InstantDrConsult</div>
            <p style={{ color: '#c4c5d5', fontSize: '0.85rem', lineHeight: 1.65 }}>Precise care delivered through the fusion of human empathy and artificial intelligence.</p>
          </div>
          {[
            { title: 'Platform', links: ['AI Consultation', 'Video Calls', 'Prescriptions'] },
            { title: 'Legal', links: ['Privacy Policy', 'Terms of Service', 'Security'] },
            { title: 'Support', links: ['Contact Support', 'Accessibility'] },
          ].map(col => (
            <div key={col.title}>
              <div style={{ color: '#fff', fontWeight: 700, fontSize: '0.75rem', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '1rem' }}>{col.title}</div>
              <nav style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                {col.links.map(l => (
                  <a key={l} href="#" style={{ color: '#c4c5d5', textDecoration: 'none', fontSize: '0.85rem', transition: 'color 0.2s' }}
                    onMouseOver={e => e.target.style.color = '#b8c4ff'}
                    onMouseOut={e => e.target.style.color = '#c4c5d5'}>{l}</a>
                ))}
              </nav>
            </div>
          ))}
        </div>
        <div style={{ maxWidth: 1280, margin: '2.5rem auto 0', paddingTop: '1.5rem', borderTop: '1px solid rgba(68,70,83,0.1)', textAlign: 'center' }}>
          <p style={{ color: '#c4c5d5', fontSize: '0.82rem' }}>© 2024 InstantDrConsult. Precise Care, Human Touch.</p>
        </div>
      </footer>

      {/* Pulse animation */}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }
        .hero-grid {
          grid-template-columns: 1fr;
        }
        @media (min-width: 1024px) {
          .hero-grid {
            grid-template-columns: 7fr 5fr;
          }
        }
      `}</style>
    </div>
  )
}
